import { InputAdornment, InputBaseComponentProps } from '@material-ui/core';
import { InfoIcon } from 'app/components/BasicIcons/InfoIcon';
import { omit } from 'lodash';
import * as React from 'react';
import BaseTextField from '../BaseTextField';
import { BaseInputFieldProps } from '../BaseTextField/BaseFieldDefinition';
import clsx from 'clsx';

export interface TextControlFieldProps extends BaseInputFieldProps {
  info?: string;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  onFocus?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  autoFocus?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  type?: React.InputHTMLAttributes<unknown>['type'];
  min?: number;
  max?: number;
  className?: string;
  inputProps?: InputBaseComponentProps;
}

export function TextControlField({
  info,
  startIcon,
  endIcon,
  onBlur,
  onChange,
  onFocus,
  autoFocus,
  variant,
  type,
  inputProps,
  className,
  ...props
}: TextControlFieldProps) {
  const startIconComponent = startIcon && (
    <InputAdornment position="start">{startIcon}</InputAdornment>
  );

  const endIconComponent = (
    <InputAdornment position="end">{endIcon}</InputAdornment>
  );
  return (
    <BaseTextField
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      autoFocus={autoFocus}
      variant={variant || 'filled'}
      type={type || 'text'}
      inputProps={inputProps}
      placeholder={props.placeholder}
      InputProps={{
        startAdornment: startIcon && startIconComponent,
        endAdornment:
          (info && <InfoIcon title={info} />) || (endIcon && endIconComponent),
      }}
      className={clsx(className, {
        startIcon: !!startIcon,
        endIcon: !!endIcon,
      })}
      {...omit(props, 'DialogProps')}
    ></BaseTextField>
  );
}
